export const formatCurrency = (num, lang, minimumFractionDigits = 2) => {
  const costFormatter = new Intl.NumberFormat(`${lang}-CA`, {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits
  })

  const result = !num ? costFormatter.format(0) : costFormatter.format(num)

  return result.replace('CA', '')
}
